// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout_container__2uPav","logo":"Layout_logo__3UKxy","header":"Layout_header__24Bwz","icon":"Layout_icon__3tLCL","content":"Layout_content__sG1AN"};